<h2 mat-subheader class="mb">{{ 'account_basic_settings.content.voicemail' | translate }}</h2>
<sound-upload [title]="'account_basic_settings.content.greating_message'|translate" [(fileEntry)]="voicemail_welcome_file" (onChange)="updateMailboxWelcomeFile($event)"></sound-upload>
